import { useFileDownload } from "../components/Common/useFileDownload";
import { useSelectedBusiness } from "../components/UserAccess/useSelectedBusiness";

export const useDownloadBulkProductAllocation = () => {
  const business = useSelectedBusiness();

  return useFileDownload(`/api/businesses/${business.id}/bulkProductAllocation/download`, `${business.name}_Inventory_Export.csv`);
}
